module.exports = __webpack_public_path__ + "static/images/r-top_startBtn02.0463587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp/images/r-top_startBtn02.png
// module id = 0DzN
// module chunks = 1